export default [
  {
    key: "increasement",
    sortable: false,
    sortField: "createdAt",
    label: "label.no",
  },
  {
    key: "chatChannelName",
    sortable: false,
    label: "field.chatChannelName",
    class: "w-half break-spaces",
  },
  {
    key: "question",
    sortable: false,
    label: "field.question",
    class: "w-half break-spaces",
  },
  {
    key: "answer",
    sortable: false,
    label: "field.answer",
    class: "w-half break-spaces",
  },
  {
    key: "createdAt",
    sortable: false,
    label: "field.createDate",
  },
  {
    key: "actions",
    label: "general.action",
  },
];
